module.exports = __webpack_public_path__ + "static/media/triviagameTextImage.18d76da5.png";